module.exports = __webpack_public_path__ + "static/media/hyper-1.111397df.PNG";